import clsx from 'clsx';
import Link from 'next/link';
import React from 'react';

import { Box, Container, Hidden } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { CSSProperties } from '@material-ui/core/styles/withStyles';

import BreezyLogo from './assets/BreezyLogo';

interface Props {
  className?: string;
  logoMobileSize?: number;
  logoDesktopSize?: number;
  style?: CSSProperties;
}

const useStyles = makeStyles<Theme, Props>((theme) => ({
  root: {
    padding: '90px 0px 0px',
  },
  navContainer: (props) => ({
    justifyContent: 'space-between',
  }),
}));

const Nav = (props: Props) => {
  const { className, logoMobileSize = 33, logoDesktopSize = 37, style } = props;
  const classes = useStyles(props);

  return (
    <nav className={clsx(classes.root, className)} style={style}>
      <Container>
        <Box display="flex" className={classes.navContainer}>
          <div>
            <Link href="/">
              <a style={{ textDecoration: 'none' }}>
                <Hidden smUp implementation="css">
                  <BreezyLogo size={logoMobileSize} />
                </Hidden>
                <Hidden xsDown implementation="css">
                  <BreezyLogo size={logoDesktopSize} />
                </Hidden>
              </a>
            </Link>
          </div>
        </Box>
      </Container>
    </nav>
  );
};

export default Nav;
